
  /**
   * Entry point for running the application.
   * Must export an object with a start() method.
   *
   * Since this is a feature, the entry point is only used for running it in isolation.
   * When consumed by a page, the entry point will be defined by the consumer.
   */
import * as $ from 'jquery';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import '@core/vendor/radio.shim'; // shim app.channel
import Example from './src/events';
import './src/scss/events.scss';
import pkg from './package.json';

/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

const PageApp = new Marionette.Application();

PageApp.getMeta = () => null;

PageApp.on('start', () => {
  //if (Backbone.history) {
    PageApp.Feature = new Example();


    const mainObject = $('#main');
    //if (mainObject.length > 0) {
      PageApp.Feature.init();
    //}
  //}
});

export default PageApp;

